<form novalidate [formGroup]="editSubDomainInfoForm">
  <div class="grid-x">
    <div class="cell large-3 medium-4 small-12"><label>Registration URL:</label></div>
    <div class="cell large-9 medium-8 small-12"><input id="regURL" formControlName="registrationurl"
                                                       placeholder="Registration URL"
                                                       class="input-group-custom" maxlength="100">
      <div class="form-error is-visible" *ngIf="displayValidationError('registrationurl')">
        <span *ngIf="this.editSubDomainInfoForm.get('registrationurl').errors.invalidURL">{{this.editSubDomainInfoForm.get('registrationurl').errors.invalidURL}}</span>
      </div>
      <div class="form-error is-visible" *ngIf="displayServerValidationError(serverConstants.REGISTRYURL_FIELD_NAME)">
        <span>{{displayServerValidationError(serverConstants.REGISTRYURL_FIELD_NAME)}}</span>
      </div>
      <div class="form-error is-visible warning-msg" *ngIf="domain | valueFromMap : serverConstants.LOCK_FIELD_NAME: serverConstants.REGISTRYURL_FIELD_NAME">
        <span>Editing of Registry URL is currently disabled as a change is pending with Request ID - {{domain | valueFromMap : serverConstants.LOCK_FIELD_NAME: serverConstants.REGISTRYURL_FIELD_NAME}}</span>
      </div>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-3 medium-4 small-12"><label>WHOIS Server:</label></div>
    <div class="cell large-9 medium-8 small-12"><input id="whois" formControlName="whoisserver"
                                                       placeholder="WHOIS Server"
                                                       class="input-group-custom" maxlength="100">
      <div class="form-error is-visible" *ngIf="displayValidationError('whoisserver')">
        <span *ngIf="this.editSubDomainInfoForm.get('whoisserver').errors.invalidHostName">{{this.editSubDomainInfoForm.get('whoisserver').errors.invalidHostName}}</span>
      </div>
      <div class="form-error is-visible" *ngIf="displayServerValidationError(serverConstants.WHOIS_FIELD_NAME)">
        <span>{{displayServerValidationError(serverConstants.WHOIS_FIELD_NAME)}}</span>
      </div>
      <div class="form-error is-visible warning-msg" *ngIf="domain | valueFromMap : serverConstants.LOCK_FIELD_NAME: serverConstants.WHOIS_FIELD_NAME">
        <span>Editing of WHOIS server is currently disabled as a change is pending with Request ID - {{domain | valueFromMap : serverConstants.LOCK_FIELD_NAME: serverConstants.WHOIS_FIELD_NAME}}</span>
      </div>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-3 medium-4 small-12"><label>RDAP Servers:</label></div>
    <div class="cell large-9 medium-8 small-12">
      <div *ngFor="let rdap of modifiedRDAPServers; let i=index;">
        <div class="grid-x">
          <div class="cell large-7 medium-8 small-12" style="display: flex">
            <fa-icon (click)="removeRdapServer(i)" [disabled]="!(domain | valueFromMap: serverConstants.LOCK_FIELD_NAME: serverConstants.RDAP_SERVER_FIELD_NAME | checkNull)" [icon]="'trash'" class="delete-icon-left align-center"></fa-icon>
            {{rdap.url}}</div>
        </div>
        <div class="form-error is-visible" *ngIf="checkForRDAPError(rdap.url)">
          <div *ngFor="let error of checkForRDAPError(rdap.url)">
            {{error}}
          </div>
        </div>
      </div>
      <input id="rdap" formControlName="rdapServer" placeholder="RDAP Server"
             class="input-group-custom" maxlength="100">
      <button style="margin-left: 16px" [disabled]="!(domain | valueFromMap: serverConstants.LOCK_FIELD_NAME: serverConstants.RDAP_SERVER_FIELD_NAME | checkNull)" class="iana-button"
              (click)="addAdditionalRdapServer()">Add
      </button>
      <div class="form-error is-visible" *ngIf="rdapErrors">
        <span *ngFor="let error of rdapErrors">{{error}}<br/></span>
      </div>
      <div class="form-error is-visible warning-msg" *ngIf="domain | valueFromMap : serverConstants.LOCK_FIELD_NAME: serverConstants.RDAP_SERVER_FIELD_NAME">
        <span>Editing of RDAP servers is currently disabled as a change is pending with Request ID - {{domain | valueFromMap : serverConstants.LOCK_FIELD_NAME: serverConstants.RDAP_SERVER_FIELD_NAME}}</span>
      </div>
      <div></div>
    </div>
  </div>
  <div class="grid-x save-cancel-button-group">
    <button class="iana-button-cancel" (click)="cancel()">{{newDelegation ? "Previous" : "Cancel"}}</button>
    <button class="iana-button" [disabled]="!editSubDomainInfoForm.valid" (click)="onSubmit()" type="submit">{{newDelegation ? "Next" : "Save"}}</button>
  </div>
</form>
